// frontend/src/hooks/useUserData.js

import { useState, useEffect } from 'react';
import { fetchUserData } from '../utils/userUtils';

export function useUserData(apiUrl, authUser) {
  const [userId, setUserId] = useState(null);
  const [sociodemographicData, setSociodemographicData] = useState({});

  useEffect(() => {
    const fetchUser = async () => {
      if (!authUser) return; // 🧤 Esperem login
      try {
        const userData = await fetchUserData(apiUrl);
        setUserId(userData.id);
        setSociodemographicData(userData);
      } catch (error) {
        console.error('⚠️ Error initializing user data:', error);
      }
    };

    fetchUser();
  }, [apiUrl, authUser]); // 🔁 S’activa quan authUser està disponible

  return { userId, sociodemographicData };
}